import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/index'),
    hidden: true,
    redirect: '/home',
    meta: { title: '首页' },
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home'),
        hidden: true,
        meta: { title: '首页', id: 0 }
      },
      {
        path: 'me',
        name: 'Me',
        component: () => import('@/views/me'),
        hidden: true,
        meta: { title: '我的', id: 2 }
      },
      {
        path: 'server',
        name: 'Server',
        component: () => import('@/views/server'),
        hidden: true,
        meta: { title: '客服' }
      }
    ]
  },
  {
    path: '/publish',
    name: 'Publish',
    component: () => import('@/views/publish'),
    hidden: true,
    meta: { title: '发布', id: 1 }
  },
  {
    path: '/pay',
    name: 'Pay',
    component: () => import('@/views/pay'),
    hidden: true,
    meta: { title: '支付' }
  },
    // {
    //     path: '/pay2',
    //     name: 'Pay2',
    //     component: () => import('@/views/pay2'),
    //     hidden: true,
    //     meta: { title: '支付页面' }
    // },
  {
    path: '/store',
    name: 'Store',
    component: () => import('@/views/store'),
    hidden: true,
    meta: { title: '招租信息' }
  },
  {
    path: '/storeInfo',
    name: 'StoreInfo',
    component: () => import('@/views/storeInfo'),
    hidden: true,
    meta: { title: '招租详情' }
  },

  {
    path: '/suggest',
    name: 'Suggest',
    component: () => import('@/views/suggest'),
    hidden: true,
    meta: { title: '意见反馈' }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/about'),
    hidden: true,
    meta: { title: '关于我们' }
  },
  {
    path: '/case',
    name: 'Case',
    component: () => import('@/views/case'),
    hidden: true,
    meta: { title: '成功案例' }
  },
  {
    path: '/position',
    name: 'Position',
    component: () => import('@/views/position'),
    hidden: true,
    meta: { title: '城市切换' }
  },
  {
    path: '/published',
    name: 'Published',
    component: () => import('@/views/published'),
    hidden: true,
    meta: { title: '我的发布' }
  },
  {
    path: '/rent',
    name: 'Rent',
    component: () => import('@/views/rent'),
    hidden: true,
    meta: { title: '求租用户信息' }
  },
    {
        path: '/promise',
        name: 'Promise',
        component: () => import('@/views/promise'),
        hidden: true,
        meta: { title: '用户协议' }
    }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => ({ y: 0 })
})

export default router

